export default "__VITE_ASSET__D$hEstf2__"